import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { makeDefaultStylingContext } from '../tornado/utils/style';
import { middle, SCREEN_WIDTH, SCREEN_HEIGHT } from '../tornado/utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const SPINNER_SIZE = {
  [HD]: 200,
  [FULL_HD]: 200,
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize } = context;
  const spinnerSize = SPINNER_SIZE[screenSize];

  return {
    w: SCREEN_WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    Wrapper: {
      forceZIndexContext: true,
      pivot: 0,
      w: SCREEN_WIDTH[screenSize],
      h: SCREEN_HEIGHT[screenSize],
      Spinner: {
        alpha: 0,
        mount: 0.5,
        zIndex: 1,
        w: spinnerSize,
        h: spinnerSize,
        x: middle,
        y: middle,
      },
      Subtitles: {
        zIndex: 1,
      },
      Controls: {
        zIndex: 2,
      },
      Player: {
        // NOTE: it's important to keep the player above the controls.
        // The only visual component of the Player is a JingleImage, and
        // jingles should always render on top of everything.
        zIndex: 3,
      },
      PauseAds: {
        zIndex: 4,
      },
      NextVideo: {
        zIndex: 5,
        visible: false,
      },
    },
  };
};
